import { useState } from "react";
import { MapPin, Loader2 } from "lucide-react";
import { publicApi } from "@/api";

const inputCls = "w-full h-14 px-4 text-lg bg-white border border-slate-300 rounded-xl focus:border-emerald-600 focus:ring-2 focus:ring-emerald-600/20 outline-none transition";
const labelCls = "text-sm font-semibold text-slate-700 mb-2 block";

export default function UbicacionStep({ onNext, onBack, loading }) {
  const [cp, setCp] = useState("");
  const [locs, setLocs] = useState(null);
  const [sel, setSel] = useState("");
  const [searching, setSearching] = useState(false);

  const buscar = async (value) => {
    setCp(value);
    setSel("");
    setLocs(null);
    if (/^\d{4}$/.test(value)) {
      setSearching(true);
      try {
        const { data } = await publicApi.get(`/public/params/localidades?cp=${value}`);
        setLocs(data);
        if (data.length) {
          const principal = data.find((l) => l.subcodpos === "0") || data[0];
          setSel(`${principal.codpos}|${principal.subcodpos}|${principal.localidad}|${principal.codpro}`);
        }
      } catch {
        setLocs([]);
      } finally {
        setSearching(false);
      }
    }
  };

  const continuar = () => {
    if (!sel) return;
    const [codpos, subcodpos, localidad, codpro] = sel.split("|");
    onNext({ cp: codpos, sub_cp: subcodpos !== "0" ? subcodpos : "", localidad_desc: localidad, provincia: codpro });
  };

  return (
    <div data-testid="step-ubicacion">
      <h1 className="font-heading text-3xl font-bold text-slate-900 mb-2">¿Donde circulas?</h1>
      <p className="text-slate-500 mb-6">El codigo postal de donde esta tu moto influye en el precio.</p>
      <div className="space-y-5">
        <div>
          <label className={labelCls} htmlFor="cp-input">Codigo postal</label>
          <input id="cp-input" data-testid="cp-input" className={inputCls} inputMode="numeric" maxLength={4} placeholder="Ej: 1686"
            value={cp} onChange={(e) => buscar(e.target.value.replace(/\D/g, ""))} />
        </div>
        {searching && <div className="flex items-center gap-2 text-slate-500"><Loader2 className="w-4 h-4 animate-spin" /> Buscando localidad...</div>}
        {locs && locs.length === 0 && !searching && (
          <p className="text-red-600 text-sm bg-red-50 border border-red-200 rounded-xl p-3" data-testid="cp-not-found">No encontramos ese codigo postal. Revisalo e intenta de nuevo.</p>
        )}
        {locs && locs.length > 0 && (
          <div>
            <label className={labelCls} htmlFor="localidad-select">Localidad</label>
            <select id="localidad-select" data-testid="localidad-select" className={inputCls} value={sel} onChange={(e) => setSel(e.target.value)}>
              {locs.map((l, i) => (
                <option key={i} value={`${l.codpos}|${l.subcodpos}|${l.localidad}|${l.codpro}`}>{`${l.localidad} - ${l.provincia}`}</option>
              ))}
            </select>
            <div className="flex items-center gap-2 mt-3 text-slate-500 text-sm">
              <MapPin className="w-4 h-4" />
              <span>{locs[0].provincia}</span>
            </div>
          </div>
        )}
      </div>
      <div className="fixed bottom-0 left-0 right-0 p-4 pb-[max(1rem,env(safe-area-inset-bottom))] sm:p-6 bg-white/85 backdrop-blur-xl border-t border-slate-200 sm:border-t-0 sm:bg-transparent sm:backdrop-blur-none z-50">
        <div className="max-w-xl mx-auto flex gap-3 sm:bg-white sm:border sm:border-slate-200 sm:rounded-full sm:p-2 sm:shadow-xl">
          <button data-testid="wizard-back-button" onClick={onBack} className="h-14 px-6 rounded-[14px] border border-slate-300 text-slate-700 font-medium transition">Atras</button>
          <button data-testid="ubicacion-next-button" disabled={!sel || loading} onClick={continuar}
            className="flex-1 h-14 rounded-[14px] bg-[#1C1C1E] hover:bg-zinc-800 disabled:bg-slate-300 text-white font-heading font-semibold text-lg transition flex items-center justify-center gap-2">
            {loading && <Loader2 className="w-5 h-5 animate-spin" />}
            {loading ? "Cotizando..." : "Ver precios"}
          </button>
        </div>
      </div>
    </div>
  );
}
